export enum UnitType {
  mg = 0,
  ml = 1,
  g = 2,
}

export const unitTypeTypes = (): Record<UnitType, string> => ({
  [UnitType.mg]: 'mg',
  [UnitType.ml]: 'ml',
  [UnitType.g]: 'g',
})
